import { mod10, mod11 } from './../util/checksum';
import { banks } from './banks';

export const accountNumberValidation = (accountnumber: string): { bank_name?: string, clearing_number?: string, account_number?: string, isValid?: boolean } => {
    let bank: any, controlDigit: any
    for (const i in banks) {
        bank = banks[i];
        controlDigit = accountnumber.substr(-bank.lengths.control, bank.lengths.control);
        if (bank.regex.test(accountnumber) && ((bank.modulo === 11 && mod11(controlDigit)) || (bank.modulo === 10 && mod10(controlDigit)))) {
            return {
                bank_name: bank.name,
                clearing_number: accountnumber.substr(0, bank.lengths.clearing),
                account_number: accountnumber.substr(bank.lengths.clearing, bank.lengths.account)
            };
        }
    }
    return { isValid: false };
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./~/@teamui/validation/validation/BankAccount/accountNumber.ts
 **/